import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagGuard {
    constructor(
        private router: Router,
        private featureFlagService: FeatureFlagService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const featureFlag = route.data['featureFlag'];
        const canActivate = this.featureFlagService.isFeatureFlagEnabled(featureFlag);

        if (!canActivate) {
            this.router.navigate(['/']);
        }

        return canActivate;
    }
}
